// Returns a project's localized text field (e.g. "short_description" or
// "description") for the given language, falling back to German if the
// requested language hasn't been translated yet.
export function localized(project, field, lang) {
  if (!project) return "";
  return project[`${field}_${lang}`] || project[`${field}_de`] || "";
}
